<template>
<div :ref="loadingobj">    

    <div>
        <div class="TTL-form-submit-box">
            <span class="TTL-box-title">微信小程序设置</span>
            <!-- appid -->
            <div class="TTL-form-submit-box-in top40">
                <span class="TTL-box-item-title">appid</span>
                <wcinput class="left20"
                    :option="{type:'input',placeholder:'修改appid',clearable:true,ischange:true,width:'500px',isinput:true,iskeydown:true,clearable:true}" 
                    :value="xcxsettinginfo.appid"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            xcxsettinginfo.appid=val.value;
                            UpdateSetting(xcxsettinginfo.id,'appid',xcxsettinginfo.appid);
                        }
                    }"
                />
            </div>
            <!-- appsecret -->
            <div class="TTL-form-submit-box-in top20">
                <span class="TTL-box-item-title">secret</span>
                <wcinput class="left20"
                    :option="{type:'input',placeholder:'修改secret',clearable:true,ischange:true,width:'500px',isinput:true,iskeydown:true,clearable:true}" 
                    :value="xcxsettinginfo.secret"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            xcxsettinginfo.secret=val.value;
                            UpdateSetting(xcxsettinginfo.id,'secret',xcxsettinginfo.secret);
                        }
                    }"
                />
            </div>
            <!-- mchid -->
            <div class="TTL-form-submit-box-in top20">
                <span class="TTL-box-item-title">商户号(mchid)</span>
                <wcinput class="left20"
                    :option="{type:'input',placeholder:'修改商户号',clearable:true,ischange:true,width:'500px',isinput:true,iskeydown:true,clearable:true}" 
                    :value="xcxsettinginfo.mchid"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            xcxsettinginfo.mchid=val.value;
                            UpdateSetting(xcxsettinginfo.id,'mchid',xcxsettinginfo.mchid);
                        }
                    }"
                />
            </div>
            <!-- mch_secret -->
            <div class="TTL-form-submit-box-in top20">
                <span class="TTL-box-item-title">商户号密钥(mch_secret)</span>
                <wcinput class="left20"
                    :option="{type:'input',placeholder:'修改商户号密钥',clearable:true,ischange:true,width:'500px',isinput:true,iskeydown:true,clearable:true}" 
                    :value="xcxsettinginfo.mch_secret"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            xcxsettinginfo.mch_secret=val.value;
                            UpdateSetting(xcxsettinginfo.id,'mch_secret',xcxsettinginfo.mch_secret);
                        }
                    }"
                />
            </div>
            <!-- 支付回调地址 -->
            <div class="TTL-form-submit-box-in top20">
                <span class="TTL-box-item-title">支付回调地址</span>
                <wcinput class="left20"
                    :option="{type:'input',placeholder:'修改支付回调地址',clearable:true,ischange:true,width:'500px',isinput:true,iskeydown:true,clearable:true}" 
                    :value="xcxsettinginfo.notify_url"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            xcxsettinginfo.notify_url=val.value;
                            UpdateSetting(xcxsettinginfo.id,'notify_url',xcxsettinginfo.notify_url);
                        }
                    }"
                />
            </div>


            <span class="TTL-box-title top50">微信公众号设置</span>
            <!-- Qrcode -->
            <div class="TTL-form-submit-box-in top20">
                <span class="TTL-box-item-title">公众号二维码</span>
                <wcupload :option="{size:'large', phototype:'system'}" 
                    class="left20"
                    :value="gzhsettinginfo.qrcode" 
                    @finish="(val)=> {
                        gzhsettinginfo.qrcode=val.url;
                        UpdateGzhSetting(gzhsettinginfo.id,'qrcode',gzhsettinginfo.qrcode);
                    }" 
                />
            </div>
            <!-- appid -->
            <div class="TTL-form-submit-box-in top20">
                <span class="TTL-box-item-title">appid</span>
                <wcinput class="left20"
                    :option="{type:'input',placeholder:'修改appid',clearable:true,ischange:true,width:'500px',isinput:true,iskeydown:true,clearable:true}" 
                    :value="gzhsettinginfo.appid"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            gzhsettinginfo.appid=val.value;
                            UpdateGzhSetting(gzhsettinginfo.id,'appid',gzhsettinginfo.appid);
                        }
                    }"
                />
            </div>
            <!-- appsecret -->
            <div class="TTL-form-submit-box-in top20">
                <span class="TTL-box-item-title">appsecret</span>
                <wcinput class="left20"
                    :option="{type:'input',placeholder:'修改appsecret',clearable:true,ischange:true,width:'500px',isinput:true,iskeydown:true,clearable:true}" 
                    :value="gzhsettinginfo.appsecret"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            gzhsettinginfo.appsecret=val.value;
                            UpdateGzhSetting(gzhsettinginfo.id,'appsecret',gzhsettinginfo.appsecret);
                        }
                    }"
                />
            </div>
            <!-- 会员注册推送模板id -->
            <div class="TTL-form-submit-box-in top20">
                <span class="TTL-box-item-title">会员注册消息推送模板id</span>
                <wcinput class="left20"
                    :option="{type:'input',placeholder:'修改会员注册消息推送模板id',clearable:true,ischange:true,width:'500px',isinput:true,iskeydown:true,clearable:true}" 
                    :value="gzhsettinginfo.register_templateid"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            gzhsettinginfo.register_templateid=val.value;
                            UpdateGzhSetting(gzhsettinginfo.id,'register_templateid',gzhsettinginfo.register_templateid);
                        }
                    }"
                />
            </div>
            <!-- 会员注册推送模板id -->
            <div class="TTL-form-submit-box-in top20">
                <span class="TTL-box-item-title">会员跟进提醒消息推送模板id</span>
                <wcinput class="left20"
                    :option="{type:'input',placeholder:'修改会员跟进提醒消息推送模板id',clearable:true,ischange:true,width:'500px',isinput:true,iskeydown:true,clearable:true}" 
                    :value="gzhsettinginfo.customer_follow_templateid"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            gzhsettinginfo.customer_follow_templateid=val.value;
                            UpdateGzhSetting(gzhsettinginfo.id,'customer_follow_templateid',gzhsettinginfo.customer_follow_templateid);
                        }
                    }"
                />
            </div>
            <!-- 订单支付成功消息推送模板id -->
            <div class="TTL-form-submit-box-in top20">
                <span class="TTL-box-item-title">会员订单支付成功消息推送模板id</span>
                <wcinput class="left20"
                    :option="{type:'input',placeholder:'修改订单支付成功消息推送模板id',clearable:true,ischange:true,width:'500px',isinput:true,iskeydown:true,clearable:true}" 
                    :value="gzhsettinginfo.order_pay_templateid"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            gzhsettinginfo.order_pay_templateid=val.value;
                            UpdateGzhSetting(gzhsettinginfo.id,'order_pay_templateid',gzhsettinginfo.order_pay_templateid);
                        }
                    }"
                />
            </div>

        </div>
    </div>

</div>
</template>

<script>
import INTERFACE_MODEL_SETTING from '@/Interface/Es/setting';

export default {
    components:{},
    data() {
        return {
            loadingobj:'wxloading',
            xcxsettinginfo:[], //小程序设置信息      
            gzhsettinginfo:[], //公众号设置信息
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetxcxSettingInfo(); //获取小程序配置信息
            this.GetgzhSettingInfo(); //获取公众号配置信息
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.GetxcxSettingInfo(); //获取小程序配置信息
                this.GetgzhSettingInfo(); //获取公众号配置信息

            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                
            }
        },


        //////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////
        //小程序设置信息

        //获取小程序设置信息
        GetxcxSettingInfo() {
            INTERFACE_MODEL_SETTING.GET_XCX_SETTING().then((res) => {
                if(res.status > 0) return false;
                this.xcxsettinginfo=res.data;
            });
        },

        //修改小程序信息
        UpdateSetting(id,key,val) {
            INTERFACE_MODEL_SETTING.SAVE_XCX_SETTING({id:id,key:key,value:val}).then((res) => {
                if(res.status > 0) return false;
            });
        },


        //////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////
        //小程序设置信息

        GetgzhSettingInfo() {
            INTERFACE_MODEL_SETTING.GET_Wx_GZH_SETTING().then((res) => {
                if(res.status > 0) return false;
                this.gzhsettinginfo=res.data;
            });
        },

        //修改小程序信息
        UpdateGzhSetting(id,key,val) {
            INTERFACE_MODEL_SETTING.SAVE_Wx_GZH_SETTING({id:id,key:key,value:val}).then((res) => {
                if(res.status > 0) return false;
            });
        },


    },
}
</script>
<style scoped>
.TTL-form-submit-box {display: inline-block;width:100%;}
.TTL-box-title {display: inline-block;width:100%;font-size: 14px;font-weight: 600;}
.TTL-form-submit-box-in {display: inline-flex;width:100%;align-items: center;}
.TTL-box-item-title {font-size:13px;width:200px;text-align: left;}
</style>